import { onEvent } from "./_dom";

function toggleSection(header, title) {
	const expand = header.classList.contains("v3-state-collapsed");
	const collapse = header.classList.contains("v3-state-expanded");
	title.classList.toggle("ui-icon-collapsed", collapse);
	title.classList.toggle("ui-icon-expanded", expand);
	header.classList.toggle("v3-state-expanded", expand);
	header.classList.toggle("v3-state-collapsed", collapse);
}

function init(context) {
	onEvent(context, "section.v3-state-expanded >.v3-gridlayout-section__header, section.v3-state-collapsed >.v3-gridlayout-section__header", "click", (_e, header) => {
		toggleSection(header.parentNode, header.querySelector(".v3-gridlayout-section__title"));
	});

	// old layout
	onEvent(context, "tbody.fs-sectionheader.v3-state-expanded,tbody.fs-sectionheader.v3-state-collapsed", "click", (e, header) => {
		const title = header.querySelector(".ui-sectiontoggle");
		toggleSection(header, title);
	});
}

export { init };